@if (brukerKanRedigere()) {
  @if (stemmevektAvvikerFraAntallAksjer()) {
    <inline-melding type="advarsel" voksHorisontalt="true" class="std-margin-topp">
      {{ 'Stemmevekt er ulik antall aksjer for enkelte av de stemmeberettigede'|translate }},
      <a (click)="rediger()">{{ 'rediger for å rette på dette'|translate }}</a>
    </inline-melding>
  }

  @if (stemmeberettigede().length === 0 && moetedeltakere().length > 0) {
    <tips class="std-margin-vertikal">
      {{ 'Du har ikke lagt til noen stemmeberettigede deltakere'|translate }},
      <a (click)="rediger()" class="klikkbar">{{ 'rediger stemmeberettigede deltakere for å rette på dette'|translate }}</a>
    </tips>
  }

  @if (moetedeltakere().length === 0) {
    <tips class="std-margin-vertikal">
      {{ 'Du må legge til møtedeltakere før du kan angi hvilke av disse som er stemmeberettiget,'|translate }}
      <a (click)="redigerMoetedeltakere()" class="klikkbar">{{ 'rediger møtedeltakere for å rette på dette'|translate }}</a>
    </tips>
  }
}

@if (!erRedigermodus()) {
  @if (stemmeberettigede().length > 0) {
    <avstemning-vis-stemmeberettigede [moeteId]="moete().id"
                                      [gruppeId]="moete().eiendeGruppeId"
                                      [moetedeltakere]="stemmeberettigede()"
                                      [avstemningsstatus]="avstemningsstatus()"
                                      [visAntallAksjer]="visAntallAksjer()"
                                      (vedNullstillAvgitteStemmer)="nullstillAvgitteStemmer($event)"/>
  }
} @else {
  <avstemning-rediger-stemmeberettigede [moeteId]="moete().id"
                                        [moetedeltakere]="moetedeltakere()"
                                        [visAntallAksjer]="visAntallAksjer()"
                                        (vedLukk)="vedRedigerLukket($event)"/>
}

